module.exports = __webpack_public_path__ + "img/1453287583.97a39951.jpg";